<template>
  <div class="full-screen" v-bind:style="{ backgroundImage: 'url(' + `${user.data.otherInfo['bg-img']}` + ')'}">
    <div class="home-donations app-bg-gradient">
    <div class="stars-bg"></div>
    <div class="reciept-sec">
      <Languages class="languages" v-bind:settings="true"></Languages>
      <Timer v-if='timerStart' :setTime="setTime"></Timer>
      <div class="mosque-name">{{user.data.name}}</div>
      <div class="donations-status-sec">
        <div class="form-section">
          <div class="form-data-section">
            <h3 style="text-align:center">{{"Enter your details" | translate}}</h3>
            <form v-on:submit.prevent='sendRecipt()'>
              <input type="text" v-model="userName" @focus="changeEditingField('username')" required placeholder="Name" autofocus />
              <input type="email" v-model="email" @focus="changeEditingField('email')" required placeholder="Email"/>
              <div class="button-sec">
                <div @click="moveToHome" class="no-thanks cursor">{{"No, Thanks" | translate}}</div>
                <div class="btn-bg1">
                  <div class="btn-bg2">
                    <button class="cursor login">{{"Send" | translate}}</button>
                  </div>
                </div>
              </div>
            </form>
            <div v-if="emailStatus" class="email-status-sec">
              <div class="backdrop">
                <div class="email-status">{{emailStatus | translate}}</div>
              </div>
            </div>
          </div>
          <div class="footer">{{"All Donations are Voluntary , T &amp; C applies" | translate}} </div>
        </div>
        <div class="key-board-section">
          <Keypad @change="changeUserName" v-if="editingPlace === 'username'" :username="userName"/>
          <Keyboard @change="changeEmail" v-if="editingPlace !== 'username'" :emailId="email"/>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Timer from './timer.vue'
import Languages from './Languages'
import Keypad from './keypad'
import Keyboard from './keyboard'

export default {
  data () {
    return {
      amount: null,
      donationName: null,
      userName: '',
      email: '',
      setTime: null,
      timerStart: true,
      tid: null,
      paymentId: null,
      dataToChange: '',
      editingPlace: 'username',
      emailStatus: null
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'token'
    ])
  },
  methods: {
    ...mapActions([
      'changeLoadingStatus',
      'sendMail',
      'resetEmailStatus'
    ]),
    moveToHome () {
      localStorage.removeItem('payment-status')
      localStorage.removeItem('payment-req-status')
      localStorage.removeItem('donation-type')
      localStorage.removeItem('donation-amount')
      localStorage.removeItem('email-status')
      this.resetEmailStatus()
      this.$router.push({path: `/${this.tid}/donations`})
    },
    sendRecipt () {
      let userName = this.userName
      let email = this.email
      let donationType = this.donationName
      let donationAmount = this.amount
      let paymentId = this.paymentId
      if (this.userName && this.email) {
        this.sendMail({userName, email, donationType, donationAmount, paymentId}).then((res) => {
          this.emailStatus = res.message
          if (res.status === 'Success') {
            setTimeout(() => {
              this.emailStatus = false
              this.moveToHome()
            }, 3000)
          } else {
            setTimeout(() => {
              this.emailStatus = false
            }, 3000)
          }
        })
        .catch((error) => {
          this.emailStatus = error.message
          setTimeout(() => {
            this.emailStatus = false
          }, 3000)
        })
      }
    },
    changeUserName (a) {
      this.userName = a
    },
    changeEmail (a) {
      this.email = a
    },
    changeEditingField (a) {
      this.editingPlace = a
      if (a === 'username') {
        this.dataToChange = this.userName
      } else {
        this.dataToChange = this.email
      }
    }
  },
  components: {
    Timer,
    Languages,
    Keypad,
    Keyboard
  },
  mounted: function () {
    this.donationName = this.$route.params.donationType
    this.amount = this.$route.params.donateAmount
    this.tid = this.$route.params.terminalId
    this.paymentId = this.$route.params.paymentId
    this.$nextTick(() => {
      // Check wether the user has been already logged in.
      if (!this.token) {
        this.$router.push({path: `/${this.tid}/`})
      } else {
        this.changeLoadingStatus(false)
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .home-donations {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }
  .mosque-name {
    font-size: 40px;
    color: #FFF;
    font-family: "Lato";
    font-weight: bold;
    text-shadow: 1px 1.732px 4px rgba( 0, 0, 0, 0.45 );
    margin-top: 61px;
    margin-bottom: 40px;
    letter-spacing: 2px;
    text-align: center;
  }
  .donations-status-sec {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 132px);
    flex-direction: column;
    width: 100%;
  }
  .donations-status-sec > div {
    height: 50%;
    min-height:50%;
    width:100vw;
  }
  .donations-status-sec > div:first-child {
    min-height: 280px;
    position: relative;
  }
  .donations-status-sec h3 {
    color: #880913;
    font-size: 22px;
    font-weight: 600;
    margin: 0;
    margin-bottom: 15px;
  }
  .donations-status-sec h3 .errormsg {
    font-size: 32px;
  }
  .btn-bg1 {
    margin-top: 0px;
  }
  .retry {
    margin-right: 30px;
  }
  .btns-sec {
    display: flex;
  }
  .donations-status-sec > div.form-section {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .form-section > .form-data-section {
    width: 30%;
    background-color: rgba(255,255,255,0.14);
    height: 95%;
    padding: 0.5% 3%;
    border-radius: 2%;
    position: relative;
  }
  form {
    width: 100%;
  }


  .button-sec {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .button-sec .no-thanks {
    color: #FFF;
    font-weight: 600;
  }
  input {
    border: none;
    border-bottom: 1px solid #812d03;
    background-color: transparent;
    color: #FFF;
    font-size: 20px;
    outline: none;
    width:100%;
    height: 45px;
    padding: 0 5px;
    cursor: pointer;
    margin-bottom: 20px;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }
  .email-status-sec {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255,255,255,0.95);
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    color: #880913;
    font-size: 35px;
    border-radius: 2%;
  }
  .reciept-sec {
    z-index: 2;
  }

  .donations-status-sec > div.key-board-section {
    width: 50vw;
  }
  .email-status {
    line-height: 45px;
    text-align: center;
  }
.full-screen {
  background-position: 50%;
}

  @media only screen and (min-width: 2000px) {
    .form-section > .form-data-section {
      width: 40%;
      padding: 4%;
    }
    .donations-status-sec h3 {
      font-size: 90px;
      letter-spacing: 6px;
    }
    input {
      font-size: 118px;
      height: auto;
      padding: 2% 2% 2% 1%;
      background-position: 98% 60%;
      background-size: 70px;
      text-indent: 1%;
      border-bottom-width: 4px;
      margin-bottom: 200px;
    }
    .donations-status-sec {
      height: 80vh;
      align-items: flex-start;
      justify-content: flex-start;
    }
    .donations-status-sec > div.form-section {
      height: 35vh !important;
    }
    .footer {
      bottom: -10% !important;
    }
    .donations-status-sec > div.key-board-section {
      /* margin-top: 10%; */
      width: 100%;
    }
    .donations-status-sec {
      justify-content: space-between;
    }
    .button-sec .no-thanks {
      font-size: 65px;
      line-height: 65px;
    }
    .btn-bg1 {
      margin-top: 00px;
      z-index: 2;
      width: 620px !important;
      height: 200px !important;
      border-radius: 200px;
    }
    .btn-bg2 {
      width: 610px;
      height: 190px;
      border-radius: 200px;
    }
    .btn-bg2 button {
      width: 594px;
      height: 184px;
      border-radius: 200px;
      font-size: 70px;
      letter-spacing: 3px;
    }
    .button-sec {
      margin-top: -50px;
    }
  }
@media screen and (min-width: 1200px) and (min-height: 904px) {
  .donations-status-sec > div.key-board-section {
    width: 100%;
  }
  .donations-status-sec > div:last-child {
    height: 55%;
  }
  .donations-status-sec > div:first-child {
    height: 45%;
  }
  .donations-status-sec h3 {
    font-size: 22px;
    margin-top: 16px;
  }
  input {
    font-size: 22px;
    height: 55px;
  }
  .form-section>.form-data-section {
    height: 85%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reciept.vue